import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { type DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import { type Connection1cFindInterface, Connection1cFindDto } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';

import * as yup from 'yup';

export interface DealSynchronizeHistoryInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Deal which was synchronized with 1C ERP database */
  deal?: DealFindInterface;
  /** Connection to the 1C ERP database with which the deal was synchronized */
  connection?: Connection1cFindInterface;
  /** Synchronization date and time */
  date: Date;
  /** Is synchronization succeed */
  success: boolean;
  /**
   * Synchronization failure reason (exists only if
   * {@link DealSynchronizeHistoryFindDto.success} property equals `false`)
   */
  error?: string;
}

export const DealSynchronizeHistoryDto = SerdeDtoClass.create<DealSynchronizeHistoryInterface>(BusinessDtoKeysEnum.DEAL_SYNCHRONIZE_HISTORY_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  deal: {
    optional: true,
    label: 'Сделка',
    nested: BusinessDtoKeysEnum.DEAL_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  connection: {
    optional: true,
    label: 'Соединение',
    nested: Connection1cFindDto,
    serializer: (_, nested) => nested,
  },
  date: {
    label: 'Дата',
    serializer: yup.date(),
  },
  success: {
    label: 'Успех',
    serializer: yup.boolean(),
  },
  error: {
    optional: true,
    label: 'Ошибка',
    serializer: yup.string(),
  },
});
